// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__6MBZh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2cIPX"};